import React from 'react'

import * as S from './styles'

export interface FilterTagProps {
  /**
   * Text contente of the tag
   *
   * @example
   * ```tsx
   *
   * <FilterTag text="This is a Filter Tag" />
   * ```
   *
   */
  text: string
  /**
   * Function to be executed when the tag is clicked
   *
   * @example
   * ```tsx
   * <FilterTag onClick={() => console.log('clicked')} />
   * ```
   *
   */
  onClick?: () => void
  /**
   * Validation when tag is selected
   *
   * @example
   * ```tsx
   * <FilterTag selected={selected === item} />
   * ```
   *
   */
  selected: boolean
}

export const FilterTag: React.FC<FilterTagProps> = ({
  text,
  selected,
  ...props
}) => (
  <S.Tag {...props} hasClick={!!props.onClick}>
    <span className={selected ? 'selected' : ''}>
      {text}
      <div className="fill" />
    </span>
  </S.Tag>
)
